import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[stripSpecialChars]'
})
export class StripSpecialCharsDirective {

  regexStr = '^[a-zA-Z0-9!@#$%^&*()-=_+]*$';

  constructor(private _el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onKeypress(event) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zA-Z0-9!@#$%^&*()-=_+]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/strip-special-chars.directive.ts